<template>
  <div class="mt-4">
    <filter-bar @set-new-report-params="setNewReportParams"></filter-bar>
    <div class="md-layout">
      <div class="md-layout-item content">
        <report-empty-state
          v-if="hasNoReportView"
          :title="$t('attendance_report.student.empty_state_title')"
          :desc="$t('attendance_report.student.empty_state_desc')"
        ></report-empty-state>
        <detail
          v-else
          ref="detail"
          :detail="reportData.table_detail"
          :percent_status="reportData.percent_status"
          :check_status="checkStatus"
          @changePage="changePage"
        ></detail>
      </div>
    </div>
  </div>
</template>

<script>
import FilterBar from "./FilterBar.vue";
import Detail from "./Detail.vue";
import ReportEmptyState from "@/pages/Report/Components/EmptyState.vue";
import { service_paths } from "@/constants/Services";

export default {
  components: {
    FilterBar,
    Detail,
    ReportEmptyState
  },
  data() {
    return {
      reportParams: {},
      reportData: {
        table_detail: {},
        percent_status: {}
      },
      hasNoReportView: true,
      checkStatus: false
    };
  },
  methods: {
    async handleReport(reportParams) {
      if (!reportParams.hasOwnProperty("page") && !this.hasNoReportView) {
        this.$refs.detail.resetPage();
      }
    },
    changePage(page) {
      let param = { ...this.reportParams, page: page };
      this.handleReport(param);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    setNewReportParams(reportParams) {
      this.reportParams = { ...reportParams, class_status: "On-going" };
      this.hasNoReportView = false;
      this.fetchPercentStatus();
      this.fetchStudentInfo();
    },
    fetchPercentStatus() {
      this.$axios
        .get(`${service_paths.attendances}/percent-status`, this.reportParams)
        .then(response => {
          this.reportData.percent_status = response.data;
          let percents = Object.values(this.reportData.percent_status);
          this.checkStatus = percents.some(item => item.percent != 0);
        });
    },
    fetchStudentInfo() {
      this.$axios
        .get(`${service_paths.reports}/attendance/by-class`, this.reportParams)
        .then(response => {
          this.reportData.table_detail = response.data;
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
